<template>
    <div class="modal">
        <div class="modal-container">

            <div class="modal-header">
                <close-icon v-on:click="closeView"></close-icon>
                <h1 v-if="type === 'full'">Full Page Views</h1>
                <h1 v-else-if="type === 'copies'">Content Copies</h1>
                <h1 v-else>Views</h1>
            </div>

            <div class="modal-body no-pad">
                <div class="flex h-full">
                    <div class="w-full">
                        <div class="analytics-body" v-if="data">
                            <p>The total number of results is <strong>{{ data.length }}</strong></p>
                            <div class="results-list">
                                <div class="results-row">
                                    <div class="results-head" data-width="60%">User</div>
                                    <div class="results-head" data-width="40%">Date/Time</div>
                                </div>
                                <div class="results-row" v-for="(row, index) in data" :key="index">
                                    <div class="results-cell analytics-cell" data-width="60%" v-if="!row.user">
                                        <span class="guest account-type">Guest</span>
                                    </div>
                                    <div class="results-cell analytics-cell" data-width="60%" v-else>
                                        <span class="account account-type">Account</span>
                                        {{ row.user.email }}
                                    </div>
                                    <div class="results-cell" data-width="40%">{{ formatDateShort(row.datetime) }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="modal-footer">
                <div class="flex">
                    <div class="right text-right">
                        <button class="btn-tertiary muted" type="button" @click="closeView">Close</button>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>
<script>
    export default {
        name: 'ReleasesAnalytics',
        props: {
            type: String,
        },
        data () {
            return {
                data: {}
            }
        },
        mounted() {
            this.setMetaTitle('List Analytics | JournoLink Control')
            window.addEventListener('keyup', this.handleKeypress)

            this.loadData(this.type)
        },
        beforeDestroy() {
            window.removeEventListener('keyup', this.handleKeypress)
        },
        methods: {
            /**
             * Get analytics data
             *
             * @param {String} type
             */
            loadData(type) {
                axios.get(route(this.getRouteForType(type), this.$route.params.releaseId))
                    .then(response => {
                        this.data = response.data
                    })
                    .catch(e => {
                        console.error({e})
                    })
            },
            /**
             * Determine Correct Route for Type of Analytics
             *
             * @param {String} type
             * @return {String}
             */
            getRouteForType: function (type) {
                switch (type) {
                    case 'copies':
                        return 'releases.analytics.copies'
                    case 'full':
                        return 'releases.analytics.full'
                    default:
                        return 'releases.analytics.views'
                }
            },
            /**
             * Emit the close event to the parent
             *
             * @return {void}
             */
            closeView () {
                this.$root.goBack()
            },
            /**
             * Handle an [Escape] keypress
             *
             * @return {void}
             */
            onEscapeKeypress() {
                this.closeView()
            },
        },
    }
</script>

<style lang="less">
    .analytics-body {
        padding: 15px;

        .analytics-cell {
            .account-type {
                padding: 5px;
                border-radius: 3px;
                color: white;
            }

            .account {
                background-color: #2980b9;

            }

            .guest {
                background-color: #2c3e50;
            }
        }
    }
</style>
